import { concatMap, tap } from 'rxjs';
import { httpService } from '@services/http';
import { logger } from '@services/logger';
import { HttpServiceBase, RxUtils } from '@utils';

export class SupportService extends HttpServiceBase {
	constructor() {
		super('support');
	}

	contactUs(title: string, message: string) {
		return httpService.post<string>(this.getUrl(), 'contact-us', { body: { title, message } }).pipe(
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			tap((result) => logger.debug(`[${this.constructor.name}.${this.contactUs.name}]`, result))
		);
	}
}

export const supportService = new SupportService();
